import React, {useState, useEffect, useRef} from "react";
import {ServerResponse} from "../../../models/models";
import {RESPONSE_TYPES} from "../../../constants";
import BackButton from "../../common/buttons/BackButton";
import GenericButton from "../../common/buttons/GenericButton";
import {setPreferredMethod} from "../../../api/requests";
import CardItem from "../../common/items/CardItem";
import GenericItem from "../../common/items/GenericItem";
import NoCardsItem from "../../common/items/NoCardsItem";
import {handleError} from "../../../helpers/helpers";
import PlanToggleSwitchRow from "../../common/subscriptions/PlanToggleSwitchRow";

const ManagePage = (props: {
    data: Object,
    pages: Object,
    setPage: Function,
    setPayNow: Function,
    setLoading: Function,
    setServerResponse: Function,
    setShouldRefresh: Function,
    preferredPaymentMethod: Object,
    paymentType: number,
    hasSubscription: boolean,
    setDoNotRenew: Function
}) => {
    const {
        data,
        pages,
        setPage,
        setPayNow,
        setLoading,
        setServerResponse,
        setShouldRefresh,
        preferredPaymentMethod,
        paymentType,
        hasSubscription,
        setDoNotRenew
    } = props;

    const {allPaymentMethods, doNotRenew, expirationDate} = data || {};

    const [selectedDoNotRenew, setSelectedDoNotRenew] = useState(doNotRenew);

    const firstUpdate = useRef(true);

    const [selectedMethod, setSelectedMethod] = useState(null);

    const otherPaymentOptions = allPaymentMethods?.length - 1 > 0;

    const onShowPreferredSelectInput = () => {
        setLoading(true);
        setPreferredMethod(paymentType, selectedMethod.paymentMethodId, handleSetPreferredMethodResult);
    }

    const handleSetPreferredMethodResult = (result) => {
        setLoading(false);
        if (result.status !== 200) {
            console.error('Failed to save payment data');
            handleError(result, i18n.payments.error.genericServerError, setServerResponse);
            return;
        } else if (result.data.error !== null && result.data.error !== undefined) {
            setServerResponse(new ServerResponse(RESPONSE_TYPES.error, i18n.payments.error.genericTitle,
                result.data.error));
            return;
        }

        setShouldRefresh(val => !val);
    };

    useEffect(() => {
        setPayNow(false);
    }, []);

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }

        setLoading(true);
        setDoNotRenew(selectedDoNotRenew, (result) => {
            setLoading(false);
            if (result.status !== 200) {
                console.error('Failed to set do not renew');
                handleError(result, i18n.payments.error.genericServerError, setServerResponse);
                return;
            }

            setShouldRefresh(val => !val);
        });
    }, [selectedDoNotRenew]);

    function setSelectBackToDefault() {
        setSelectedMethod(preferredPaymentMethod);
    }

    const onUpdateSubscriptionClick = () => {
        setPage(pages.UPDATE_SUBSCRIPTION);
    };

    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <PlanToggleSwitchRow selectedDoNotRenew={doNotRenew}
                                     setSelectedDoNotRenew={setSelectedDoNotRenew}/>

                <div style={{
                    display: "grid",
                    gridAutoFlow: "column",
                    columnGap: "10px",
                    alignItems: "end",
                    width: "fit-content"
                }}>
                    {
                        preferredPaymentMethod ? (
                            <CardItem paymentMethod={preferredPaymentMethod}
                                      planExpirationDate={expirationDate}
                                      isSelected={false}
                                      onClick={setSelectBackToDefault}
                                      key={preferredPaymentMethod.paymentMethodId}
                                      preferredMethod={true}/>
                        ) : (
                            <>
                                <NoCardsItem/>
                                <GenericItem title={i18n.payments.noPreferredPaymentMethodMsg}/>
                            </>
                        )
                    }

                    {
                        allPaymentMethods.map((paymentMethod) => {
                            const onClick = () => {
                                setSelectedMethod(paymentMethod);
                            }

                            if (preferredPaymentMethod.paymentMethodId !== paymentMethod.paymentMethodId) {
                                return <CardItem paymentMethod={paymentMethod}
                                                 setLoading={setLoading}
                                                 handleError={handleError}
                                                 showPreferredTags={true}
                                                 setServerResponse={setServerResponse}
                                                 allPaymentMethods={allPaymentMethods}
                                                 isSelected={selectedMethod && selectedMethod.paymentMethodId === paymentMethod.paymentMethodId}
                                                 onClick={onClick}/>
                            }
                        })
                    }
                </div>
                <div className={"flexSpaceBetween footerMargins"}>
                    <BackButton onClick={() => setPage(pages.SPLASH)}/>

                    <div className={'flex'}>
                        {
                            otherPaymentOptions && (selectedMethod && selectedMethod.paymentMethodId !== preferredPaymentMethod.paymentMethodId) && (
                                <GenericButton onClick={onShowPreferredSelectInput}
                                               text={i18n.payments.setAsPreferred}/>
                            )}
                        {
                            hasSubscription && (
                                <GenericButton onClick={onUpdateSubscriptionClick}
                                               text={i18n.payments.changeSubscription}/>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ManagePage;